import { ReactElement } from 'react';
import { SButton } from './Button.style';
import { InternalButtonProps } from './InternalButton';

export type ButtonProps = InternalButtonProps;

export const Button = (props: InternalButtonProps): ReactElement => <SButton {...props} />;
